import React from "react";

export const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
    <path d="m3.5 6.5 8.5 6 8.5-6" />
  </svg>
);

export const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
    <path d="M8 10.5V7.6a4 4 0 0 1 8 0v2.9" />
  </svg>
);

export const KeyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="8" cy="12" r="4.2" />
    <path d="M12.2 12H21" />
    <path d="M18 12v3" />
    <path d="M15 12v2.2" />
  </svg>
);

export const AttendanceIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M15 20v-1.8a3.8 3.8 0 0 0-3.8-3.8H6.3A3.8 3.8 0 0 0 2.5 18.2V20" />
    <circle cx="8.75" cy="7.2" r="3.7" />
    <path d="m15.6 11.3 2.2 2.2 4-4" />
  </svg>
);

export const RfidIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 10v4" />
    <path d="M9.5 7.4a6.6 6.6 0 0 1 0 9.2" />
    <path d="M13.8 5a10.5 10.5 0 0 1 0 14" />
    <path d="M18.1 2.6a14.4 14.4 0 0 1 0 18.8" />
  </svg>
);

export const ReportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 20V13" />
    <path d="M12 20V5" />
    <path d="M19 20v-4.5" />
  </svg>
);

export const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M15.5 20v-1.8a3.8 3.8 0 0 0-3.8-3.8H5.8A3.8 3.8 0 0 0 2 18.2V20" />
    <circle cx="8.75" cy="7.2" r="3.7" />
    <path d="M17.5 4.2a3.7 3.7 0 0 1 0 6.9" />
    <path d="M22 20v-1.8a3.8 3.8 0 0 0-2.9-3.7" />
  </svg>
);

export const AbsentIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14.5 20v-1.8a3.8 3.8 0 0 0-3.8-3.8H5.8A3.8 3.8 0 0 0 2 18.2V20" />
    <circle cx="8.25" cy="7.2" r="3.7" />
    <path d="m16.5 8.5 5 5" />
    <path d="m21.5 8.5-5 5" />
  </svg>
);

export const SiteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 21h18" />
    <path d="M5.5 21V6.2a1.7 1.7 0 0 1 1.7-1.7h6.1a1.7 1.7 0 0 1 1.7 1.7V21" />
    <path d="M15 10.5h2.8a1.7 1.7 0 0 1 1.7 1.7V21" />
    <path d="M9 8.5h2.5" />
    <path d="M9 12.5h2.5" />
    <path d="M9 16.5h2.5" />
  </svg>
);
